import { z } from 'zod';
export const IMMUNIZATION_CATALOG = [
    {
        code: 'MMR',
        label: 'MMR (measles, mumps, rubella)',
        description: 'Usually two documented doses or bloodwork showing immunity.',
    },
    {
        code: 'VARICELLA',
        label: 'Varicella (chickenpox)',
        description: 'Usually two doses, documented previous infection, or bloodwork showing immunity.',
    },
    {
        code: 'HEPATITIS_B',
        label: 'Hepatitis B',
        description: 'Particularly important when your work may expose you to blood or bodily fluids. Bloodwork may be required to confirm immunity.',
    },
    {
        code: 'TDAP',
        label: 'Tdap (tetanus, diphtheria, pertussis)',
        description: 'A tetanus/diphtheria booster is generally needed every 10 years.',
    },
    {
        code: 'POLIO',
        label: 'Polio',
        description: 'Proof that you completed the primary vaccine series.',
    },
    {
        code: 'INFLUENZA',
        label: 'Influenza (flu)',
        description: 'Generally requested every year; some workplaces may impose additional measures during outbreaks if you decline.',
    },
    {
        code: 'COVID_19',
        label: 'COVID-19',
        description: 'Recommended, but there is no universal Ontario healthcare-worker mandate.',
    },
];
const IMMUNIZATION_BY_CODE = new Map(IMMUNIZATION_CATALOG.map((i) => [i.code, i]));
/** True iff `code` is a known immunization code. Guards the set-immunizations
 *  write so the DB never stores an out-of-catalog code. */
export function isImmunizationCode(code) {
    return IMMUNIZATION_BY_CODE.has(code);
}
/** Display label for an immunization code; falls back to the raw code. */
export function immunizationLabel(code) {
    return IMMUNIZATION_BY_CODE.get(code)?.label ?? code;
}
/** Full-set replace request for the caregiver's voluntary immunization
 *  declaration (mirrors `CaregiverSetSkillsRequestSchema`). Bounded to match the
 *  skills sibling — codes are catalog-validated in the service regardless, but
 *  the schema caps element length + array size as defense-in-depth. */
export const CaregiverSetImmunizationsRequestSchema = z.object({
    immunizationCodes: z.array(z.string().min(1).max(40)).max(IMMUNIZATION_CATALOG.length),
});
//# sourceMappingURL=immunization-catalog.js.map